import { makeStyles } from 'tss-react/mui'
import { ProductStatus } from '../../modules/productsListing/types'

export const useStyles = makeStyles<{
  status?: string
  detailView?: boolean
  isEditEnable?: boolean
}>()((theme, { detailView, isEditEnable, status }) => ({
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: theme.spacing(4),
    padding: theme.spacing(2, 5),
    backgroundColor: theme.palette.text.white,
    boxShadow: `0px -1px 0px 0px ${theme.palette.labraV2BoxShadow.dark} inset`,
    position: 'sticky',
    zIndex: 99,
    top: 0,
  },
  appTitleHeading: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: 'fit-content',
  },
  appBackIcon: {
    display: 'flex',
    margin: 'auto',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  backIcon: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    fontSize: theme.spacing(3),
    padding: theme.spacing(0, 1.5, 0, 0),
    color: theme.palette.select.light,
  },
  appTitleHeadingText: {
    fontSize: '28px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '36px',
    color: theme.palette.labraText.primary,
  },
  root: {
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(4),
    gap: theme.spacing(4),
  },
  leftContainer: {
    overflowX: 'hidden',
    overflowY: 'auto',
  },
  subStatusContainer: {
    margin: theme.spacing(-2, 0),
    display: 'flex',
    flexDirection: 'row',
    opacity: !detailView || !isEditEnable ? '38%' : '',
    pointerEvents:
      (!detailView || !isEditEnable) &&
      status !== ProductStatus.PRODUCT_STATUS_AWS_TESTING
        ? 'none'
        : 'auto',
  },
  cloneContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: '38%',
    pointerEvents: 'none',
  },
  editContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(3),
    cursor: 'pointer',
    opacity:
      status === ProductStatus.PRODUCT_STATUS_AWS_TESTING ||
      !detailView ||
      !isEditEnable
        ? '38%'
        : '',
    pointerEvents:
      status === ProductStatus.PRODUCT_STATUS_AWS_TESTING ||
      !detailView ||
      !isEditEnable
        ? 'none'
        : 'auto',
  },
  moreContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(3),
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.select.light,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    opacity: !detailView || !isEditEnable ? '38%' : '',
    pointerEvents: !detailView || !isEditEnable ? 'none' : 'auto',
  },
  subStatusHeadingContainer: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.select.light,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    marginLeft: theme.spacing(1),
  },
  actionIcon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    fontSize: theme.spacing(2),
    color: theme.palette.select.light,
  },
  hourglassIcon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    fontSize: theme.spacing(2),
    color: theme.palette.labraText.primary,
    padding: theme.spacing(1, 1, 1, 2),
  },
  marketplaceLinkIcon: {
    width: theme.spacing(1.75),
    height: theme.spacing(1.875),
    marginLeft: theme.spacing(1.25),
    color: theme.palette.select.light,
  },
  modalIcon: {
    width: theme.spacing(2.5),
    height: theme.spacing(2),
  },
  rightContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    maxHeight: '80vh',
    maxWidth: theme.spacing(53.375),
  },
  mainTabContainer: {
    marginTop: theme.spacing(3),
  },
  mainTabContent: {
    marginTop: theme.spacing(3),
  },
  formDisabled: {
    zIndex: 98,
    position: 'relative',
    opacity: 0.9,
  },
  rootFooter: {
    height: theme.spacing(8),
    padding: theme.spacing(1.5, 5),
  },
  statusContent: {
    color: theme.palette.labraText.tertiary,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  subContentStatus: {
    color: theme.palette.labraText.description,
    fontSize: '11px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0.5px',
  },
  paddingBottom: {
    paddingBottom: theme.spacing(8),
  },
  stickyStatusListing: {
    position: 'sticky',
    top: theme.spacing(10.75),
    zIndex: 1,
  },
  modalText: {
    fontSize: theme.typography.body2.fontSize,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: theme.typography.body2.lineHeight,
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
    width: theme.spacing(52.5),
  },
  modalTextHeaderContainer: {
    marginTop: theme.spacing(-2),
  },
  modalTextNoteContainer: {
    marginBottom: theme.spacing(-1),
  },
  nameBoldText: {
    fontSize: theme.typography.body2.fontSize,
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: theme.typography.body2.lineHeight,
    letterSpacing: '0.1px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  linkWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  editNote: {
    width: '100%',
    marginTop: theme.spacing(-2.5),
    backgroundColor: theme.palette.bgTertiary.main,
    display: 'flex',
    alignItems: 'center',
    borderRadius: theme.spacing(0.5),
  },
  noteText: {
    padding: theme.spacing(1),
  },
  failedStatus: {
    marginBottom: theme.spacing(5),
  },
  publicUrl: {
    display: 'flex',
  },
  submitButton: {
    marginLeft: theme.spacing(2),
  },
  errorSubContent: {
    marginTop: theme.spacing(-0.5),
  },
  errorMsg: {
    margin: theme.spacing(-0.5, 0, 1.5, 0),
  },
  offerUpdatedAt: {
    fontSize: '11px',
    fontWeight: 500,
    color: theme.palette.labraText.description,
  },
  disabledBtn: {
    opacity: '38%',
    pointerEvents: 'none',
  },
}))
